import { Injectable } from '@angular/core';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { DirectMovesBackendService } from './direct-moves-backend.service';
import { DetailedEntityActionService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-action.service';
import { DirectMovesDataEditorService } from './direct-moves-data-editor.service';
import { SearchStatus } from '../../../../shared/search/models/search-status.model';
import { ViewTransactionsPopupComponent } from '../../../../shared/components/common/view-transactions-popup/view-transactions-popup.component';
@Injectable()
export class DirectMovesActionService extends DetailedEntityActionService {


  protected backendService: DirectMovesBackendService;
  protected dataEditor: DirectMovesDataEditorService;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  // Method for show transactions similar to ASN screen.
  public viewTransactionBalance() {

      const storerValue = this.dataService.primaryDataMap['storerKey'].cVal;
      if (!storerValue || storerValue.trim().length === 0) {
        this.alertService.error(this.resourceService.get('msg_storer_not_provided'));
        return false;
      }

      const skuValue = this.dataService.primaryDataMap['sku'].cVal;
      if (!skuValue || skuValue.trim().length === 0) {
        this.alertService.clearAll().error(this.resourceService.get('msg_sku_not_provided'));
        return false;
      }
      const searchCriteria: any = {
        conditions: [
          {
            mandatory: false,
            clauses: [
              {
                column: 'storerKey',
                operation: '=',
                value: storerValue,
                logicalOperation: null
              },
              {
                column: 'sku',
                operation: '=',
                value: skuValue,
                logicalOperation: 'AND'
              }],
            logicalOperation: null
          }
        ]
      };
      this.alertService.clearAll();
      const modalRef: any = this.sharedServiceRegistry.sceModalService
      .showModal(ViewTransactionsPopupComponent,
        {
          overlayHeader: this.resourceService.get('btn_view_line_transaction'),
          showHeader: true,
          overlayHeight: 480,
          overlayWidth: 1024
        });
    modalRef.content
      .initialize(this.dataService.primarySearchService
        .searchParams.tableId, searchCriteria);
  }

  public executeMoves() {
    const moveDetails: any = [];
    let request: any;
    // LFWM-3191- passing tableId in the request.
    const tableId = this.dataService.primarySearchParams.tableId;
    const storerValue = this.dataService.primaryDataMap['storerKey'].cVal;
    //LFWM-3730 removed the validation for storerkey, sku, lot and Id
    // storerKey is a mandatory field and it should not be simply a space
    // if (!storerValue || storerValue.trim().length === 0) {
    //   this.alertService.clearAll().error(this.resourceService.get('msg_storer_not_provided'));
    //   return;
    // }
    // sku is a mandatory field and it should not be simply a space
    const skuValue = this.dataService.primaryDataMap['sku'].cVal;
    // if (!skuValue || skuValue.trim().length === 0) {
    //   this.alertService.clearAll().error(this.resourceService.get('msg_sku_not_provided'));
    //   return;
    // }
    // lot is a mandatory field and it should not be simply a space
    const lotValue = this.dataService.primaryDataMap['lot'].cVal;
    // if (!lotValue || lotValue.trim().length === 0) {
    //   this.alertService.clearAll().error(this.resourceService.get('msg_lot_not_provided'));
    //   return;
    // }
    // loc is a mandatory field and it should not be simply a space
    const fromLocValue = this.dataService.primaryDataMap['loc'].cVal;
    if (!fromLocValue || fromLocValue.trim().length === 0) {
      this.alertService.clearAll().error(this.resourceService.get('msg_from_loc_not_provided'));
      return;
    }
    // toLoc is a mandatory field and it should not be simply a space
    const toLocValue = this.dataService.primaryDataMap['toLoc'].cVal;
    if (!toLocValue || toLocValue.trim().length === 0) {
      this.alertService.clearAll().error(this.resourceService.get('msg_to_loc_not_provided'));
      return;
    }
    // toId is a mandatory field and it should not be simply a space
    const toIdValue = this.dataService.primaryDataMap['toId'].cVal;
    // if (!toIdValue || toIdValue.trim().length === 0) {
    //   this.alertService.clearAll().error(this.resourceService.get('msg_to_id_not_provided'));
    //   return;
    // }

    moveDetails.push({
      storerKey: this.dataService.primaryDataMap['storerKey'].cVal,
      sku: this.dataService.primaryDataMap['sku'].cVal,
      lot: this.dataService.primaryDataMap['lot'].cVal,
      loc: this.dataService.primaryDataMap['loc'].cVal,
      id: this.dataService.primaryDataMap['movableUnit'].cVal,
      toLoc: this.dataService.primaryDataMap['toLoc'].cVal,
      toId: this.dataService.primaryDataMap['toId'].cVal,
      toQty: this.dataService.primaryDataMap['toQty'].cVal ? this.dataService.primaryDataMap['toQty'].cVal : 0,
      toPackKey: this.dataService.primaryDataMap['toPackKey'].cVal,
      toUom: this.dataService.primaryDataMap['toUom'].cVal,
      taskManMove: 'N'
    });
    // LFWM-3191- passing tableId in the request.
    request = {
      'moveDetails': moveDetails,
      'proccedWithWarning': 'N',
      'warnNo': 0,
      'tableId': tableId
    };

    this.alertService.clearAll();
    let configKey = '';
    const storerKey = this.dataService.primaryDataMap['storerKey'].cVal;
    // locMoveCheck flag check to prevent same values in from and to location
    // if from location and to location is same then set the configkey as LocMoveCheck
    if (fromLocValue && toLocValue && fromLocValue === toLocValue) {
      configKey = 'LocMoveCheck';
    }
    if (configKey) {
      this.backendService.validationForFields(configKey, storerKey)
        .subscribe((response: any) => {
          if (response['hasRights'] === 'Y') {
            this.alertService.clearAll().error(this.resourceService.get('msg_invalid_inv_moves_LocMoveCheck'));
            return;
          } else {
            // LFWM-2860- changes made corresponding to the change in response structure of execute api (now response are coming as array).
            this.backendService.executeMoves(request)
              .subscribe((responses: any) => {
                responses.statusDetails.forEach((resp: any) => {
                  if (resp['status'] === 200 && resp['statusMsg'] === 'SUCCESS') {
                    this.alertService.clearAll().success(this.resourceService.get('msg_execute_move_success'));
                    this.clearEditedFlags();
                  } else if (resp.statusMsg) {
                    if (resp.statusMsg === 'err_msg_inv_sku') {
                      this.errorMsg = this.dataService.createAlertMessage(this.resourceService.get('err_msg_inv_sku'),
                        this.dataService.primaryDataMap['sku'].cVal);
                      this.alertService.clearAll().error(this.errorMsg);
                      // LFWM-2860-If the error message coming is msg_invalid_location, combine the toloc and display
                    } else if (resp.statusMsg === 'msg_invalid_location') {
                      this.alertService.error(this.resourceService.translateServerResponse(resp.statusMsg) + resp['toloc']);
                    } else {
                      this.alertService.error(this.resourceService.translateServerResponse(resp.statusMsg));
                    }
                    // If the errMsg was empty then below error message was shown.It is a temprorary fix need to handle it from backend
                  } else {
                    this.alertService.error(this.resourceService.get('err_msg_exe_move_fail'));
                  }
                });
              }, (error: any) => {
                this.alertService.clearAll().error(this.resourceService.get(error));
              });
          }
        });
      // if from location and to location is different then call directly call execute moves directly
    } else {
      this.backendService.executeMoves(request)
        .subscribe((responses: any) => {
          responses.statusDetails.forEach((resp: any) => {

            if (resp['status'] === 200 && resp['statusMsg'] === 'SUCCESS') {
              this.alertService.clearAll().success(this.resourceService.get('msg_execute_move_success'));
              this.clearEditedFlags();
            } else if (resp.statusMsg) {
              if (resp.statusMsg === 'err_msg_inv_sku') {
                this.errorMsg = this.dataService.createAlertMessage(this.resourceService.get('err_msg_inv_sku'),
                  this.dataService.primaryDataMap['sku'].cVal);
                this.alertService.clearAll().error(this.errorMsg);
                // LFWM-2860-If the error message coming is msg_invalid_location, combine the toloc and display
              } else if (resp.statusMsg === 'msg_invalid_location') {
                this.alertService.error(this.resourceService.translateServerResponse(resp.statusMsg) + resp['toloc']);
              } else {
                this.alertService.error(this.resourceService.translateServerResponse(resp.statusMsg));
              }
              // If the errMsg was empty then below error message was shown.It is a temprorary fix need to handle it from backend
            } else {
              this.alertService.error(this.resourceService.get('err_msg_exe_move_fail'));
            }
          });
        }, (error: any) => {
          this.alertService.clearAll().error(this.resourceService.get(error));
        });
    }

  }

  // method used to validate the values of storerKey, sku, loc, lot
  public validationForField(property: string, value: any) {
    const lookupParams = this.dataEditor.createLookupParamsForColumn(property);
    const defaultSearchCriteria = this.dataEditor.createSearchCriteriaForValidation(property, value, lookupParams);
    const searchStatus = new SearchStatus();
    const searchService = this.sharedServiceRegistry.createSearchService(lookupParams,
      searchStatus);
    searchService.setSearchCriteria(defaultSearchCriteria);
    searchService.getFirstItemForSearchCriteria(
      this.dataService.primarySearchService.formatSearchCriteria(defaultSearchCriteria, null))
      .subscribe((response: any) => {
        const hasErrors: boolean = !response || response.errors || !response.cells;
        if (hasErrors) {
          if (property === 'storerKey' && value) {
            this.errorMsg = this.dataService.createAlertMessage(this.resourceService.get('err_msg_inv_storer'), value);
            this.alertService.clearAll().error(this.errorMsg);
          } else if (property === 'sku' && value) {
            this.errorMsg = this.dataService.createAlertMessage(this.resourceService.get('err_msg_inv_sku'), value);
            this.alertService.clearAll().error(this.errorMsg);
          } else if (property === 'loc' && value) {
            this.errorMsg = this.dataService.createAlertMessage(this.resourceService.get('err_msg_inv_loc'), value);
            this.alertService.clearAll().error(this.errorMsg);
          } else if (property === 'lot' && value) {
            this.errorMsg = this.dataService.createAlertMessage(this.resourceService.get('err_msg_inv_lot'), value);
            this.alertService.clearAll().error(this.errorMsg);
          }
        }
      });
  }

  public autoPopulateForLotField(value: any) {
    this.backendService.autoPopulateForLotField(value).
      subscribe((resp: any) => {
        if (resp['statusCode'] && resp['statusMessage']) {
          if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
            this.dataService.primaryDataMap['storerKey'].cVal = resp.storer;
            this.dataService.primaryDataMap['sku'].cVal = resp.commodity;
          }
        } else {
          this.errorMsg = this.dataService.createAlertMessage(resp['statusMessage'], value);
          this.alertService.clearAll().error(this.errorMsg);
        }
      });
  }

  public validateStorer() {
    if (!this.dataService.primaryDataMap['storerKey'].cVal) {
      this.alertService.clearAll().error(this.resourceService.get('msg_storer_not_provided'));
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/direct-moves/services/direct-moves-action.service.ts